import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-2xl font-bold" style={{ fontFamily: 'var(--font-heading)' }}>
            <span className="text-primary-500">073</span>
            <span className="text-foreground-950">漫画网</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium whitespace-nowrap">
            首页
          </Link>
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium whitespace-nowrap"
            >
              {cat.name}
            </Link>
          ))}
          <Link to="/about" className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium whitespace-nowrap">
            关于我们
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <div className="relative">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-foreground-700 text-lg"></i>
            </button>
            {searchOpen && (
              <div className="absolute right-0 top-12 w-72 bg-background-50 border border-background-200 rounded-lg shadow-lg p-3 z-50">
                <div className="flex items-center gap-2 bg-background-100 rounded-md px-3 py-2">
                  <i className="ri-search-line text-foreground-500 text-sm"></i>
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="搜索漫画..."
                    className="bg-transparent border-none outline-none text-sm text-foreground-950 w-full placeholder:text-foreground-500"
                  />
                </div>
              </div>
            )}
          </div>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-700 text-lg`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium py-2">
              首页
            </Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} onClick={() => setMobileOpen(false)} className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium py-2">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" onClick={() => setMobileOpen(false)} className="text-foreground-700 hover:text-primary-500 transition-colors text-sm font-medium py-2">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}